module.exports = __webpack_public_path__ + "static/media/IsThisTooGoodToBeTrue.cf3edfd8.png";